import { Component, OnInit } from '@angular/core';
import { ElaborazioniClimaticheService } from './elaborazioni-climatiche.service';

@Component({
  selector: 'elaborazioni-climatiche',
  templateUrl: './elaborazioni-climatiche.component.html',
  styleUrls: ['./elaborazioni-climatiche.component.scss'],
  providers: [ElaborazioniClimaticheService]
})
export class ElaborazioniClimaticheComponent implements OnInit {

  modelList: any[] = [];
  promiseBusy: Promise<any[]>;

  constructor(private restService: ElaborazioniClimaticheService) { }

  ngOnInit() {
    this.createDocumentiList();
  }

  createDocumentiList() {
    this.restService.selectAll().then(
      res => {
        if (!res || res.length === 0) { 
          this.modelList = [];
          return;
        }
        
        let modelAggregate = {}; 
        
        res.documentiBindList.forEach(item => {
          let tipo = item.idCategoria;
  
          if (!modelAggregate[tipo]) {
            modelAggregate[tipo] = {
              idCategoria: tipo,
              elements: []
            };
          }
  
          modelAggregate[tipo].elements.push({
            url: item.url,
            descrizione: item.descrizione
          });
        });
  
        
        this.modelList = Object.values(modelAggregate);
        console.log(this.modelList);
        console.log(this.modelList.length > 0);
        
        
        
        
      }
    ).catch(error => {
      this.modelList = [];
    });
  }


}
